export default __webpack_public_path__ + "static/media/googlePlay_download.184b6c6b.svg";